import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const Stocks = () => {
    document.title = "Anbarlar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Anbarlar", value: "/settings/stocks", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Anbarlar</h2>
                    <p>
                        Yeni anbar yaratmaq üçün nəzərdə tutulub. Yeni anbar yaratmaq üçün bu səhifəyə keçid etmək lazımdır.
                        <br />
                        Ayarlar səhifəsində <mark>Anbarlar</mark> seçimi edildikdən sonra açılan pəncərədə <NewButton>Anbar</NewButton> düyməsi ilə yaradılacaq
                        anbarın adını təyin edib <SaveButton /> düyməsini sıxmaq lazımdır.
                        <br />
                        <b>Qeyd</b>: Sahibkar, sistemdə qeydiyyatdan keçdiyi zaman <b>Əsas anbar</b> adında artıq anbar formalaşır və bütün əməliyyatlar{" "}
                        <b>Əsas anbar</b> üzərindən aparılır.
                        <br />
                        <b>Qeyd</b>: Yeni yaradılacaq anbarı, başqa anbarın içinə də yerləşdirmək olar.
                    </p>
                    <img src="/images/settings/stocks.gif" alt="Anbarlar" />
                </article>
            </div>
        </div>
    );
};
